import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './MobileMenuItem.scss';
import offersCategory from '../offers-category';
import notifyAnalytics from '../notify-analytics';

const MobileMenuItem = ({
  label,
  url,
  className,
  onClick,
  child,
  hierarchy,
}) => {
  const isButton = child?.length > 0;
  const isAnchor = url && !isButton;
  const isOffer = offersCategory(label, 1);
  const offersChildren = child?.filter(item => !!item.url) || [];

  const navigate = () => {
    notifyAnalytics([...hierarchy, label].join('|'));
  };

  if (!isAnchor && !isButton) {
    return <></>;
  }

  return (
    <li className={classNames(styles.mobileMenuItem, className)}>
      {isAnchor && (
        <a
          href={url}
          onClick={navigate}
          data-hierarchy={[...hierarchy, label].join('|')}
        >
          {label}
        </a>
      )}
      {isButton && (
        <button
          onClick={onClick}
          className={classNames(styles.mobileMenuItem__chevron, {
            [styles.offersLabel]: isOffer,
          })}
        >
          {label}
        </button>
      )}
      {isOffer && offersChildren.length > 0 && (
        <ul className={styles.offersSubMenu}>
          {offersChildren.slice(0, 3).map(subitem => (
            <li className={styles.mobileMenuItem} key={subitem.name}>
              <a href={subitem.url}>{subitem.name}</a>
            </li>
          ))}
          {offersChildren.length > 3 && (
            <li
              className={classNames(styles.mobileMenuItem, styles.viewMoreLink)}
            >
              <button onClick={onClick}>View more</button>
            </li>
          )}
        </ul>
      )}
    </li>
  );
};

MobileMenuItem.defaultProps = {
  url: '',
  className: '',
  onClick: undefined,
  child: undefined,
  hierarchy: [],
};

MobileMenuItem.propTypes = {
  label: PropTypes.string.isRequired,
  url: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  child: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string,
    })
  ),
  hierarchy: PropTypes.arrayOf(PropTypes.string),
};

export default MobileMenuItem;
